import {
    all, put, call, select, take, fork, takeLatest,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import API from '../common/API';
import * as Actions from '../actions/SeminarManagement';
import { waitAuthorizedCheck } from './Auth';
import ObjectHelper from '../common/helper/ObjectHelper';

function* waitEventInfoReceived() {
    let shortName = yield select((state) => state.eventManagement.infoEvent.data.short_name);
    if (!shortName) {
        yield take('GET_INFO_EVENT_RECEIVED');
        shortName = yield select((state) => state.eventManagement.infoEvent.data.short_name);
    }

    return shortName;
}

function* getAllSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const shortName = yield call(waitEventInfoReceived);
        const seminars = yield select((state) => state.seminars.listSeminars.data.results);
        const response = yield call(
            API.get, {
                endpoint: `/api/v1/event/${shortName}/seminar_management/`,
                body: {
                    ...(action.payload.sdate && { sdate: action.payload.sdate }),
                    ...(action.payload.edate && { edate: action.payload.edate }),
                    ...(action.payload.title && { title: action.payload.title.trim() }),
                    ...(action.payload.page && { page: action.payload.page }),
                    ...(action.payload.page_size && { page_size: action.payload.page_size }),
                },
                token: credential.data.token,
            },
        );
        let dataResults = {};
        if (seminars) {
            dataResults = { ...response, results: { ...seminars, ...response.results } };
        } else {
            dataResults = response;
        }

        yield put(Actions.GetAllSeminarRequestedReceived(dataResults));
    } catch (error) {
        yield put(Actions.GetAllSeminarRequestedReceivedFailure(yield error));
    }
}

function* getDetailSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const shortName = yield call(waitEventInfoReceived);
        const response = yield call(
            API.get, {
                endpoint: `/api/v1/event/${shortName}/seminar_management/${action.payload.seminar_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailSeminarIgnoreCompanyIdRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarIgnoreCompanyIdRequestedReceivedFailure(yield error));
    }
}

function* updateSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const shortName = yield call(waitEventInfoReceived);
        const endpoint = `/api/v1/event/${shortName}/seminar_management/${action.payload.seminar_id}/`;
        let response;

        if (action.payload?.company_id !== undefined) {
            const body = ObjectHelper.removePropertyByKey('seminar_id')(action.payload);
            const [uploadPromise, channel] = createUploadChannel({ company_id: body.company_id, ...body.data }, credential.data.token, endpoint);
            yield fork(uploadProgressWatcher, channel);

            response = yield call(() => uploadPromise);
        } else {
            response = yield call(API.put, {
                endpoint: `${endpoint}`,
                body: { ...action.payload },
                token: credential.data.token,
            });
        }

        yield put(Actions.UpdateSeminarIgnoreCompanyIdRequestedReceived(response));
    } catch (error) {
        yield put(Actions.UpdateSeminarIgnoreCompanyIdRequestedReceivedFailure(yield error));
    }
}

function createUploadChannel(payload, token, endpoint) {
    let emit;
    const chan = eventChannel((emitter) => {
        emit = emitter;
        // it's necessarily. event channel should
        // return unsubscribe function. In our case
        // it's empty function
        return () => { };
    });

    const onProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        emit(percentCompleted);
        if (percentCompleted === 100) emit(END); // 100 percent emit end
        else emit(percentCompleted);
    };

    const uploadPromise = API.putWithFile({
        endpoint,
        body: payload,
        token,
        onProgress,
    });

    return [uploadPromise, chan];
}

function* uploadProgressWatcher(channel) {
    while (true) {
        const progress = yield take(channel);
        yield put(Actions.UpdateSeminarProgress(progress));
    }
}

export default function* seminarManagement() {
    yield all([
        takeLatest('GET_ALL_SEMINAR_REQUESTED', getAllSeminar),
        takeLatest('GET_DETAIL_SEMINAR_IGNORE_COMPANY_ID_REQUESTED', getDetailSeminar),
        takeLatest('UPDATE_SEMINAR_IGNORE_COMPANY_ID_REQUESTED', updateSeminar),
    ]);
}
